const getPositionY = (item) => item.offset().top;

export default getPositionY;



// WEBPACK FOOTER //
// ./src/js/about/getPositionY.js